var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.707485 2.16199L6.8023 0.0682525C6.93106 0.0240194 7.0709 0.0240194 7.19966 0.0682525L13.2945 2.16199C13.7105 2.28838 13.9956 2.67808 13.9956 3.12028V9.5C14.1168 11.2289 12.2009 15.2759 7.18595 16.9401C7.06682 16.9797 6.93514 16.9797 6.81601 16.9401C1.80108 15.2759 -0.114873 11.2289 0.00635988 9.5L0.00635988 3.12028C0.00635988 2.67808 0.291481 2.28838 0.707485 2.16199Z",
    fill: "#00C0D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2964 2.16199L7.00293 0L7.00293 17C12.1558 15.375 14.1203 11.25 13.9975 9.5V3.12028C13.9975 2.67808 13.7124 2.28838 13.2964 2.16199Z",
    fill: "#0EA0B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49805 8.49793L6.37295 10.1229L9.62279 6.24805",
    stroke: "white",
    strokeWidth: 1.27273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceIcon);
export default __webpack_public_path__ + "static/media/insurance-icon.f41eca22afbd05a8263ac9b45c984b32.svg";
export { ForwardRef as ReactComponent };